import { defineMessages } from "react-intl";
const messages = defineMessages({
    photoshootDetailsTitle: {
        id: "app.scanRequests.photoshootDetails.title",
        defaultMessage: "Photoshoot Details",
    },
    scheduledForLabel: {
        id: "app.scanRequests.photoshootDetails.scheduledFor.label",
        defaultMessage: "Scheduled For",
    },
    arrivalWindowLabel: {
        id: "app.scanRequests.photoshootDetails.arrivalWindow.label",
        defaultMessage: "Arrival Window",
    },
    requestedSpacesLabel: {
        id: "app.scanRequests.photoshootDetails.requestedSpaces.label",
        defaultMessage: "Requested Spaces",
    },
    unitsString: {
        id: "app.scanRequests.photoshootDetails.requestedSpaces.units",
        defaultMessage: "Unit(s)",
    },
    amenityString: {
        id: "app.scanRequests.photoshootDetails.requestedSpaces.amenities",
        defaultMessage: "Amenity(s)",
    },
    spaceLabel: {
        id: "app.scanRequests.table.space.label",
        defaultMessage: "Space",
    },
    floorplanLabel: {
        id: "app.scanRequests.table.floorplan.label",
        defaultMessage: "Floorplan",
    },
    addressLabel: {
        id: "app.scanRequests.table.address.label",
        defaultMessage: "Address",
    },
    requestedByLabel: {
        id: "app.scanRequests.table.requestedBy.label",
        defaultMessage: "Requested By",
    },
    requestorLabel: {
        id: "app.scanRequests.table.requestor.label",
        defaultMessage: "Requestor",
    },
    canceledByLabel: {
        id: "app.scanRequests.table.canceledBy.label",
        defaultMessage: "Canceled By",
    },
    reScanLabel: {
        id: "app.scanRequests.table.reScan.label",
        defaultMessage: "Re-scan",
    },
    previewLabel: {
        id: "app.scanRequests.table.preview.label",
        defaultMessage: "Preview",
    },
    lastCaptureLabel: {
        id: "app.scanRequests.table.lastCapture.label",
        defaultMessage: "Last Capture",
    },
    reasonLabel: {
        id: "app.scanRequests.table.reason.label",
        defaultMessage: "Reason",
    },
    spacesScheduledLabel: {
        id: "app.scanRequests.table.spacesScheduled.label",
        defaultMessage: "Scheduled Spaces",
    },
    spacesCanceledLabel: {
        id: "app.scanRequests.table.spacesCanceled.label",
        defaultMessage: "Canceled Spaces",
    },
    spacesCanceledMessage: {
        id: "app.scanRequests.table.spacesCanceled.message",
        defaultMessage: "Canceled spaces",
    },
    spacesCompletedText: {
        id: "app.scanRequests.table.spacesCompleted.label",
        defaultMessage: "Completed Spaces",
    },
    noCompletedRequestsText: {
        id: "app.scanRequests.table.noCompletedRequests.text",
        defaultMessage: "No completed requests found",
    },
    cancelSelectedButton: {
        id: "app.scanRequests.table.cancelSelected.button",
        defaultMessage: "Cancel Selected",
    },
    reasonNeedToReschedule: {
        id: "app.scanRequests.table.cancel.reason.needToReschedule",
        defaultMessage: "Need to reschedule",
    },
    reasonSpaceNotReady: {
        id: "app.scanRequests.table.cancel.reason.spaceNotReady",
        defaultMessage: "Space not ready",
    },
    reasonSpaceIsNoLongerAvailable: {
        id: "app.scanRequests.table.cancel.reason.spaceIsNoLongerAvailable",
        defaultMessage: "Space is no longer available",
    },
    reasonNoLongeWantToCapture: {
        id: "app.scanRequests.table.cancel.reason.noLongerWantToCapture",
        defaultMessage: "No longer want to capture",
    },
    cancelAllSpacesAlert: {
        id: "app.scanRequests.table.cancelAllSpaces.alert",
        defaultMessage: "All Spaces scheduled for {date} have been selected, continuing will cancel the entire photoshoot altogether. Would you like to proceed?",
    },
    cancelSpacesMessage: {
        id: "app.scanRequests.table.cancelSpaces.message",
        defaultMessage: "Cancel the spaces below scheduled for {date}?",
    },
    confirmCancellationText: {
        id: "app.scanRequests.table.cancel.confirmation.text",
        defaultMessage: "Yes, confirm cancellation",
    },
    doneText: {
        id: "app.scanRequests.table.cancel.done.text",
        defaultMessage: "Done",
    },
    nevermindText: {
        id: "app.scanRequests.table.cancel.nevermind.text",
        defaultMessage: "Nevermind",
    },
    showHistoryButton: {
        id: "app.scanRequests.table.showHistory.button",
        defaultMessage: "Show History",
    },
    hideHistoryButton: {
        id: "app.scanRequests.table.hideHistory.button",
        defaultMessage: "Hide History",
    },
    photoshootHistoryTitle: {
        id: "app.scanRequests.photoshootHistory.title",
        defaultMessage: "Photoshoot History",
    },
    todayText: {
        id: "app.scanRequests.photoshootHistory.today",
        defaultMessage: "Today",
    },
    updateRequestsErrorMessage: {
        id: "app.scanRequests.table.updateRequests.error",
        defaultMessage: "Error cancelling requests",
    },
    submitNewRequestText: {
        id: "app.scanRequests.table.cancel.submitNewRequest.text",
        defaultMessage: "Submit New Scan Request",
    },
    noPhotoshootsText: {
        id: "app.scanRequests.table.noPhotoshoots.text",
        defaultMessage: "No shoots were scheduled on this day",
    },
    spacesNumber: {
        id: "app.scanRequests.table.spacesNumber",
        defaultMessage: "{amount} Space(s)",
    },
    canceledText: {
        id: "app.scanRequests.table.canceled.text",
        defaultMessage: "Canceled",
    },
    yesterdayText: {
        id: "app.scanRequests.photoshootHistory.yesterday",
        defaultMessage: "Yesterday",
    },
    noCanceledRequestsText: {
        id: "app.scanRequests.table.noCanceledRequests.text",
        defaultMessage: "No canceled requests found",
    },
    noScheduledRequestsText: {
        id: "app.scanRequests.table.noScheduledRequests.text",
        defaultMessage: "No scheduled requests found",
    },
    spacesSkippedText: {
        id: "app.scanRequests.table.spacesSkipped.text",
        defaultMessage: "Skipped Spaces",
    },
    noSkippedRequestsText: {
        id: "app.scanRequests.table.noSkippedRequests.text",
        defaultMessage: "No skipped requests found",
    },
    uncapturedText: {
        id: "app.scanRequests.table.uncaptured.text",
        defaultMessage: "Un-captured",
    },
    thisShootText: {
        id: "app.scanRequests.table.thisShoot.text",
        defaultMessage: "This shoot",
    },
    pendingUploadText: {
        id: "app.scanRequests.table.pendingUpload.text",
        defaultMessage: "Pending upload",
    },
    scannerStillWorkingMessage: {
        id: "app.scanRequests.table.scannerStillWorking.message",
        defaultMessage: "This photoshoot is still ongoing. Please check back later.",
    },
});
export default messages;
